import React from 'react';
import ToastModal from './Toast';

export function renderToastModal(root) {
    root.render(<ToastModal />);
}
